import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import { useGet } from "../../Hooks/useFetch";
import AlertMessage from "../../Components/AlertMessage";
import DataLoader from "../../Components/DataLoader";

const BoatNewReRegistrationSearch = () => {
  const [searchInput, setSearchInput] = useState("");
  const [inputError, setInputError] = useState("");
  const [searchTriggered, setSearchTriggered] = useState(false);
  const [isTransferRequired, setIsTransferRequired] = useState(false);
  const navigate = useNavigate();
  const [resPcraft, errPcraft, isLoadingPcraft, apiGetPcraft] = useGet();

  const handleSearch = () => {
    const trimmed = searchInput.trim();
    if (!trimmed) {
      setInputError("Please enter a Rego No or Personalised ID.");
      return;
    }
    setInputError("");
    setIsTransferRequired(false);
    setSearchTriggered(true);
    apiGetPcraft("/api/pcraft/pccraftsearch/" + encodeURIComponent(trimmed));
  };

  useEffect(() => {
    if (searchTriggered && !isLoadingPcraft && !errPcraft) {
      // Still current, or expired less than 12 months ago: this is a transfer, not a re-registration.
      if (resPcraft?.isTransferRequired === true) {
        setIsTransferRequired(true);
        return;
      }
      navigate("/boatnewreregistration/form", {
        state: { pcCraft: resPcraft },
      });
    }
  }, [isLoadingPcraft]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="br-container">
      <div className="new-re-registration-container">
        <div className="br-box">
          <Box>
            {errPcraft && <AlertMessage message={errPcraft} />}
            <Typography variant="h5" gutterBottom>
              Search Vessel for New Re-Registration
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              A vessel previously registered in Tasmania but expired for more
              than 12&nbsp;months. Enter the previous Rego No or Personalised ID
              to search for the vessel.
            </Typography>

            {isTransferRequired && (
              <Alert severity="warning" sx={{ mb: 2 }}>
                <AlertTitle>Transfer Required</AlertTitle>
                Do Transfer not Re-Registration. Go to{" "}
                <Link to="/transferbuyer">Buyer Transfer Form</Link>
              </Alert>
            )}

            <TextField
              label="Rego No or Personalised ID"
              value={searchInput}
              onChange={(e) => {
                setSearchInput(e.target.value);
                if (inputError) setInputError("");
                if (isTransferRequired) setIsTransferRequired(false);
              }}
              onKeyDown={(e) => e.key === "Enter" && handleSearch()}
              error={!!inputError}
              helperText={inputError}
              fullWidth
              disabled={isLoadingPcraft}
              sx={{ mb: 2 }}
            />

            <Button
              variant="contained"
              onClick={handleSearch}
              disabled={isLoadingPcraft}
              fullWidth
              sx={{ mb: 2 }}
            >
              {isLoadingPcraft ? (
                <>
                  <DataLoader isLoading={isLoadingPcraft}/>
                </>
              ) : (
                "Search"
              )}
            </Button>
            <Typography variant="body2" sx={{ mt: 2 }}>
              Don&apos;t know the Rego No or Personalised ID?{" "}
              <Link to="/boatregistration">Register as a new boat instead</Link>
            </Typography>
          </Box>
        </div>
      </div>
    </div>
  );
};

export default BoatNewReRegistrationSearch;
